<template>
  <el-container>
    <el-main v-loading="loading">
      <el-form
        v-if="form.eName"
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
        class="space-y-10"
      >
        <el-card class="card-section" shadow="hover">
          <h3 class="font-bold mb-5">基本信息</h3>
          <el-form-item label="企业名称" prop="eName">
            <el-input v-model="form.eName" @change="form.saved = false" />
          </el-form-item>
          <el-form-item label="线上文审" prop="strSeven">
            <el-select
              v-model="form.strSeven"
              multiple
              :multiple-limit="1"
              @change="form.saved = false"
              style="width: 30%"
            >
              <el-option
                v-for="user in expert"
                :key="user.id"
                :value="user.id"
                :label="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="现场评测组" prop="strRight">
            <el-select
              v-model="form.strRight"
              multiple
              :multiple-limit="3"
              @change="form.saved = false"
              style="width: 30%"
            >
              <el-option
                v-for="user in expert"
                :key="user.id"
                :value="user.id"
                :label="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="质检校核" prop="strNine">
            <el-select
              v-model="form.strNine"
              multiple
              :multiple-limit="1"
              @change="form.saved = false"
              style="width: 30%"
            >
              <el-option
                v-for="user in expert"
                :key="user.id"
                :value="user.id"
                :label="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="false" label="企业简介" prop="eRemark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.eRemark"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="报告日期" prop="reportDate">
            <el-date-picker
              type="date"
              format="yyyy年MM月dd日"
              v-model="form.reportDate"
              @change="form.saved = false"
            />
          </el-form-item>
        </el-card>
        <el-card class="card-section" shadow="hover">
          <h3 class="font-bold mb-5">评测结果分析</h3>
          <el-form-item v-if="false" label="总体情况分析" prop="p_2_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            v-if="false"
            label="三个维度的评测得分为"
            prop="p_2_1_0"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_0"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="数字化基础（A）维度" prop="p_2_1_a">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="数字化管理（B）维度" prop="p_2_1_b">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_b"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="数字化成效（C）维度" prop="p_2_1_c">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_c"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A1 设备系统评测得分" prop="p_2_1_a_0">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_0"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A11 网络建设评测得分" prop="p_2_1_a_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A11 网络建设评测选项" prop="p_2_1_a_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A12 设备数字化评测得分" prop="p_2_1_a_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A12 设备数字化评测选项" prop="p_2_1_a_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A13 设备联网评测得分" prop="p_2_1_a_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A13 设备联网评测选项" prop="p_2_1_a_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_a_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A2 数据采集评测得分" prop="p_2_1_b_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_b_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A2 数据采集评测选项" prop="p_2_1_b_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_b_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A3 信息系统评测得分" prop="p_2_1_c_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_c_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A3 信息系统评测选项" prop="p_2_1_c_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_c_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A4 信息安全评测得分" prop="p_2_1_d_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_d_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A41 网络安全评测得分" prop="p_2_1_d_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_d_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A41 网络安全评测选项" prop="p_2_1_d_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_d_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A42 数据安全评测得分" prop="p_2_1_d_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_d_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="A42 数据安全评测选项" prop="p_2_1_d_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_2_1_d_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B1 规划管理评测得分" prop="p_a_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B11 规划实施评测得分" prop="p_a_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B11 规划实施评测选项" prop="p_a_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B12 管理机制评测得分" prop="p_a_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B12 管理机制评测选项" prop="p_a_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B2 要素保障评测得分" prop="p_a_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B21 人才建设评测得分" prop="p_a_7">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_7"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B21 人才建设评测选项" prop="p_a_8">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_8"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="B22 资金保障评测得分" prop="p_a_9">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_9"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            label="企业近三年平均数字化投入总平均比例"
            prop="p_a_10"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_10"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`${form.answer11Year[2]} 年数字化情况`"
            prop="p_a_11"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_11"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`${form.answer11Year[1]} 年数字化情况`"
            prop="p_a_12"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_12"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`${form.answer11Year[0]} 年数字化情况`"
            prop="p_a_13"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_13"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="近三年平均" prop="p_a_14">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_a_14"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C1 绿色低碳评测得分" prop="p_b_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C1 绿色低碳评测选项" prop="p_b_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`${form.answer12Year[1]} 年综合能源消费`"
            prop="p_b_3"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`${form.answer12Year[0]} 年综合能源消费`"
            prop="p_b_4"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C2 产品质量评测得分" prop="p_b_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C2 产品质量评测选项" prop="p_b_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C2 产品质量情况" prop="p_b_7">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_7"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C3 市场效益评测得分" prop="p_b_8">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_8"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C31 市场表现评测得分" prop="p_b_9">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_9"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            label="企业上年度人均营业收入相比于前年变化情况"
            prop="p_b_10"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_10"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`市场表现${form.answer14Year[1]} 年情况`"
            prop="p_b_11"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_11"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`市场表现${form.answer14Year[0]} 年情况`"
            prop="p_b_12"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_12"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="C32 价值效益评测得分" prop="p_b_13">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_13"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            label="企业上年度每百元营业收入中的成本相比于前年变化情况"
            prop="p_b_14"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_14"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            v-if="false"
            label="企业近三年平均数字化投入平均比例"
            prop="p_b_15"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_15"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`价值效益${form.answer15Year[1]} 年情况`"
            prop="p_b_16"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_16"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            :label="`价值效益${form.answer15Year[0]} 年情况`"
            prop="p_b_17"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_b_17"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            v-if="false"
            label="数字化经营维度的应用场景等级判定"
            prop="p_c_1"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_c_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item
            v-if="false"
            label="产品生命周期数字化（D）"
            prop="p_c_2"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_c_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="生产执行数字化（E）" prop="p_c_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_c_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="供应链数字化（F）" prop="p_c_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_c_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="管理决策数字化（G）" prop="p_c_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_c_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="约束性场景情况" prop="p_d_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_d_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item v-if="false" label="指导性场景情况" prop="p_d_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_d_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D1*产品设计评测等级" prop="p_e_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D1*产品设计评测选项" prop="p_e_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D2 工艺设计评测等级" prop="p_e_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D2 工艺设计评测选项" prop="p_e_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D3*营销管理评测等级" prop="p_e_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D3*营销管理评测选项" prop="p_e_7">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_7"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D4 售后服务评测等级" prop="p_e_8">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_8"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="D4 售后服务评测选项" prop="p_e_9">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_e_9"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E1 计划排程评测等级" prop="p_f_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E1 计划排程评测选项" prop="p_f_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E2*生产管控评测等级" prop="p_f_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E2*生产管控评测选项" prop="p_f_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E3*质量管理评测等级" prop="p_f_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E3*质量管理评测选项" prop="p_f_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E4*设备管理评测等级" prop="p_f_7">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_7"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E4*设备管理评测选项" prop="p_f_8">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_8"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E5*安全生产评测选等级" prop="p_f_9">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_9"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E5*安全生产评测选项" prop="p_f_10">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_10"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E6*能耗管理评测等级" prop="p_f_11">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_11"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="E6*能耗管理评测选项" prop="p_f_12">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_f_12"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="F1*采购管理评测等级" prop="p_g_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_g_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="F1*采购管理评测选项" prop="p_g_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_g_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="F2*仓储物流评测等级" prop="p_g_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_g_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="F2*仓储物流评测选项" prop="p_g_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_g_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G1*财务管理评测等级" prop="p_h_1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G1*财务管理评测选项" prop="p_h_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_2"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G2 人力资源评测等级" prop="p_h_3">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_3"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G2 人力资源评测选项" prop="p_h_4">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_4"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G3 协同办公评测等级" prop="p_h_5">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_5"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G3 协同办公评测选项" prop="p_h_6">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_6"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G4 决策支持评测等级" prop="p_h_7">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_7"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="G4 决策支持评测选项" prop="p_h_8">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_h_8"
              @change="form.saved = false"
            />
          </el-form-item>
        </el-card>
        <el-card class="card-section" shadow="hover" v-if="false">
          <h3 class="font-bold mb-5">发展建议</h3>
          <el-form-item
            label="（一）数字化基础、数字化管理、数字化成效三个维度"
            prop="p_i_1"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_i_1"
              @change="form.saved = false"
            />
          </el-form-item>
          <el-form-item label="（二）数字化经营维度" prop="p_i_2">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              v-model="form.p_i_2"
              @change="form.saved = false"
            />
          </el-form-item>
        </el-card>
        <el-form-item>
          <template v-if="form.reportNum">
            <template v-if="form.d.issue * 1 === 0">
              <el-button
                @click="handleSave"
                type="primary"
                size="mini"
                :disabled="form.saved"
                >更新</el-button
              >
              <el-button
                v-if="false"
                @click="handlePush"
                type="primary"
                size="mini"
                >发布</el-button
              >
            </template>
            <a class="select-none px-4 text-center pointer-events-none" v-else
              >已发布</a
            >
            <el-button @click="handleView('')" size="mini">报告预览</el-button>
            <el-button @click="handleView('cover')" size="mini"
              >封面预览</el-button
            >
            <el-button @click="handleView('body')" size="mini"
              >正文预览</el-button
            >
            <!-- <el-button @click="handleMiniView" size="mini">简报预览</el-button> -->
          </template>
          <el-button v-else @click="handleSave" type="primary" size="mini"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import {
  addReport,
  getDeclaration,
  getReport,
  getRevenueNewList,
  patchIssue,
} from "@/api/enterprise";

export default {
  props: [
    "info",
    "evaluate",
    "evaluateScenes",
    "questionObj",
    "sceneObj",
    // 'avgData',
    "expert",
  ],
  data() {
    return {
      loading: false,
      form: {},
      rules: {
        eName: { required: true, message: "企业名称不能为空", trigger: "blur" },
        eRemark: {
          required: true,
          message: "企业简介不能为空",
          trigger: "blur",
        },
        strSeven: {
          required: true,
          message: "线上文审人不能为空",
          trigger: "blur",
        },
        strRight: {
          required: true,
          message: "现场评测组人不能为空",
          trigger: "blur",
        },
        strNine: {
          required: true,
          message: "质检校核人不能为空",
          trigger: "blur",
        },
        reportDate: {
          required: true,
          message: "报告日期不能为空",
          trigger: "blur",
        },
        p_2_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_0: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_b: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_c: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_a_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_b_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_b_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_c_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_c_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_d_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_d_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_d_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_d_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_2_1_d_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_7: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_8: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_9: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_10: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_11: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_12: { required: true, message: "数据不能为空", trigger: "blur" },
        p_a_13: { required: true, message: "数据不能为空", trigger: "blur" },
        // p_a_14: { required: true, message: '数据不能为空', trigger: 'blur' },
        p_b_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_7: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_8: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_9: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_10: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_11: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_12: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_13: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_14: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_15: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_16: { required: true, message: "数据不能为空", trigger: "blur" },
        p_b_17: { required: true, message: "数据不能为空", trigger: "blur" },
        p_c_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_c_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_c_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_c_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_c_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_d_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_d_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_7: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_8: { required: true, message: "数据不能为空", trigger: "blur" },
        p_e_9: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_7: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_8: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_9: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_10: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_11: { required: true, message: "数据不能为空", trigger: "blur" },
        p_f_12: { required: true, message: "数据不能为空", trigger: "blur" },
        p_g_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_g_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_g_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_g_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_2: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_3: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_4: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_5: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_6: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_7: { required: true, message: "数据不能为空", trigger: "blur" },
        p_h_8: { required: true, message: "数据不能为空", trigger: "blur" },
        p_i_1: { required: true, message: "数据不能为空", trigger: "blur" },
        p_i_2: { required: true, message: "数据不能为空", trigger: "blur" },
      },
      backend: {},
      opener: null,
      miniOpener: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        getDeclaration(this.info.userId).then((res) => {
          return res;
        }),
        getReport(this.info.userId).then((res) => {
          return res;
        }),
        getRevenueNewList(this.info.userId).then((res) => {
          return res;
        }),
      ])
        .then((data) => {
          try {
            this.backend = calcBackend(
              this.info,
              data[0].data,
              this.questionObj,
              this.sceneObj,
              /** this.avgData, */ (data[2].data || []).sort((a, b) =>
                a.year * 1 > b.year * 1 ? 1 : -1
              ),
              this.expert
            );
            this.form = Object.assign(
              {},
              this.form,
              { saved: true },
              transToForm(this.backend, data[1].data || {})
            );
            this.loading = false;
          } catch (e) {
            console.log("error", e);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          addReport(transToData(this.form))
            .then(() => {
              this.loading = false;
              this.$message.success("保存成功");
              this.loadData();
              this.$emit("refresh");
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$message.error("有未填写的表单，请完成后再保存！");
        }
      });
    },
    handleView(viewMode) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.opener && !this.opener.closed) {
            this.opener.close();
          }
          this.opener = window.open(`/report?mode=${viewMode}`, "report");
          const handleMessage = ({ data }) => {
            data === "getReportInfo" &&
              this.opener &&
              this.opener.postMessage(
                JSON.stringify(
                  Object.assign({}, this.form, {
                    reportDate: formatDate(this.form.reportDate).substring(
                      0,
                      10
                    ),
                  })
                )
              );
          };
          window.addEventListener("message", handleMessage);
        } else {
          this.$confirm("有未填写的表单，请完成后再查看报告！", "提示", {
            confirmButtonText: "确定",
            showClose: false,
            showCancelButton: false,
            type: "warning",
          });
        }
      });
    },
    handleMiniView() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.miniOpener && !this.miniOpener.closed) {
            this.miniOpener.close();
          }
          this.miniOpener = window.open("/mini-report", "mini-report");
          const handleMessage = ({ data }) => {
            data === "getMiniReportInfo" &&
              this.miniOpener &&
              this.miniOpener.postMessage(
                JSON.stringify(
                  Object.assign({}, this.form, {
                    reportDate: formatDate(this.form.reportDate).substring(
                      0,
                      10
                    ),
                  })
                )
              );
          };
          window.addEventListener("message", handleMessage);
        } else {
          this.$confirm("有未填写的表单，请完成后再查看报告！", "提示", {
            confirmButtonText: "确定",
            showClose: false,
            showCancelButton: false,
            type: "warning",
          });
        }
      });
    },
    handlePush() {
      if (!this.form.saved) {
        this.$confirm("报告表单有未保存的数据，请保存后再发布!", "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
        });
        return;
      }
      this.$confirm("是否确定发布报告。", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          patchIssue(this.form.userId).then((res) => {
            if (res.code === 200) {
              this.loadData();
            }
          });
        })
        .catch(() => {});
    },
  },
};

function calcBackend(
  info,
  declaration,
  questionObj,
  sceneObj,
  /** avgData, */ revenue,
  expert
) {
  const quesAnswers = info.quesAnswers
    .map((v) =>
      Object.assign({ ques: questionObj[v.quesId] }, v, {
        quesId: v.quesId * 1,
        ans: JSON.parse(v.ans),
        fileIds: JSON.parse(v.fileIds),
        otherAns: JSON.parse(v.otherAns),
      })
    )
    .map((v) =>
      Object.assign(v, {
        ans:
          v.ans instanceof Array
            ? v.ans.sort((a, b) => (a > b ? 1 : -1)).map((a) => questionObj[a])
            : questionObj[v.ans],
      })
    );
  const sceneAnswers = info.sceneAnswers
    .map((v) =>
      Object.assign({ ques: sceneObj[v.quesId] }, v, {
        quesId: v.quesId * 1,
        ans: JSON.parse(v.ans),
        fileIds: JSON.parse(v.fileIds),
      })
    )
    .map((v) =>
      Object.assign(v, {
        ans: v.ans.map((a) => sceneObj[a]),
        level: v.ans.length,
        levelName: ["无等级", "一级", "二级", "三级", "四级"][v.ans.length],
      })
    );
  const partOne = (
    declaration.partOne * 1 +
    declaration.partTwo * 1 +
    declaration.partThree * 1 +
    declaration.partFour * 1
  ).toFixed(3);
  const partTwo = (declaration.partFive * 1 + declaration.partSix * 1).toFixed(
    3
  );
  const partThree = (
    declaration.partSeven * 1 +
    declaration.partEight * 1 +
    declaration.partNine * 1
  ).toFixed(3);
  const answer1 = quesAnswers.find((a) => a.ques.i === 1);
  const answer2 = quesAnswers.find((a) => a.ques.i === 2);
  const answer3 = quesAnswers.find((a) => a.ques.i === 3);
  const answer4 = quesAnswers.find((a) => a.ques.i === 4);
  const answer5 = quesAnswers.find((a) => a.ques.i === 5);
  const answer6 = quesAnswers.find((a) => a.ques.i === 6);
  const answer7 = quesAnswers.find((a) => a.ques.i === 7);
  const answer8 = quesAnswers.find((a) => a.ques.i === 8);
  const answer9 = quesAnswers.find((a) => a.ques.i === 9);
  const answer10 = quesAnswers.find((a) => a.ques.i === 10);
  const answer11 = quesAnswers.find((a) => a.ques.i === 11);
  const answer12 = quesAnswers.find((a) => a.ques.i === 12);
  const answer13 = quesAnswers.find((a) => a.ques.i === 13);
  const answer14 = quesAnswers.find((a) => a.ques.i === 14);
  const answer15 = quesAnswers.find((a) => a.ques.i === 15);
  const scene1 = sceneAnswers.find((a) => a.ques.i === 1);
  const scene2 = sceneAnswers.find((a) => a.ques.i === 2);
  const scene3 = sceneAnswers.find((a) => a.ques.i === 3);
  const scene4 = sceneAnswers.find((a) => a.ques.i === 4);
  const scene5 = sceneAnswers.find((a) => a.ques.i === 5);
  const scene6 = sceneAnswers.find((a) => a.ques.i === 6);
  const scene7 = sceneAnswers.find((a) => a.ques.i === 7);
  const scene8 = sceneAnswers.find((a) => a.ques.i === 8);
  const scene9 = sceneAnswers.find((a) => a.ques.i === 9);
  const scene10 = sceneAnswers.find((a) => a.ques.i === 10);
  const scene11 = sceneAnswers.find((a) => a.ques.i === 11);
  const scene12 = sceneAnswers.find((a) => a.ques.i === 12);
  const scene13 = sceneAnswers.find((a) => a.ques.i === 13);
  const scene14 = sceneAnswers.find((a) => a.ques.i === 14);
  const scene15 = sceneAnswers.find((a) => a.ques.i === 15);
  const scene16 = sceneAnswers.find((a) => a.ques.i === 16);
  const sceneStr1 = scene1.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr2 = scene2.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr3 = scene3.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr4 = scene4.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr5 = scene5.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr6 = scene6.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr7 = scene7.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr8 = scene8.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr9 = scene9.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr10 = scene10.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr11 = scene11.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr12 = scene12.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr13 = scene13.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr14 = scene14.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr15 = scene15.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const sceneStr16 = scene16.ans.reduce((a, b) => (a.id > b.id ? a : b), {
    id: 0,
    name: " ",
  }).name;
  const answer4More = getAnswer4Str(answer4);
  const answer5More = getAnswer5Str(answer5);
  const answer6More = getAnswer6Str(answer6);
  const answer7More = getAnswer7Str(answer7);
  const answer8More = getAnswer8Str(answer8);
  const answer9More = getAnswer9Str(answer9);
  const answer10More = getAnswer10Str(answer10);
  const sceneParts = calcScenes(sceneAnswers);
  const scoreLevel =
    declaration.score >= 80
      ? "四级"
      : declaration.score >= 60
      ? "三级"
      : declaration.score >= 40
      ? "二级"
      : declaration.score >= 20
      ? "一级"
      : "无等级";
  const scenesLevel = [
    ["无等级", "无等级", 0],
    ["初始级", "一级", 1],
    ["规范级", "二级", 2],
    ["集成级", "三级", 3],
    ["协同级", "四级", 4],
  ].find((v) => v[0] === declaration.levels) || ["无等级", "无等级", 0];
  const levelsName = scenesLevel[1];
  const sceneMainStr = getSceneMainStr([
    scene1,
    scene3,
    scene6,
    scene7,
    scene8,
    scene9,
    scene10,
    scene11,
    scene12,
    scene13,
  ]);
  const sceneNormalStr = getSceneNormalStr([
    scene2,
    scene4,
    scene5,
    scene14,
    scene15,
    scene16,
  ]);
  const sceneLevels = sceneAnswers.reduce(
    (o, v) => {
      o.all[v.level].push(v);
      o.count += v.level > 0 ? 1 : 0;
      if (v.ques.isMain) {
        o.main[v.level]++;
        o.mainCount += v.level > 0 ? 1 : 0;
      } else {
        o.normal[v.level]++;
        o.normalCount += v.level > 0 ? 1 : 0;
      }
      return o;
    },
    {
      all: [[], [], [], [], []],
      normal: [0, 0, 0, 0, 0],
      main: [0, 0, 0, 0, 0],
      count: 0,
      mainCount: 0,
      normalCount: 0,
    }
  );
  const sceneUpperArr = [
    [
      sceneLevels.all.slice(1).reduce((a, b) => a + b.length, 0),
      sceneLevels.main.slice(1).reduce((a, v) => a + v),
    ],
    [
      sceneLevels.all.slice(2).reduce((a, b) => a + b.length, 0),
      sceneLevels.main.slice(2).reduce((a, v) => a + v),
    ],
    [
      sceneLevels.all.slice(3).reduce((a, b) => a + b.length, 0),
      sceneLevels.main.slice(3).reduce((a, v) => a + v),
    ],
    [
      sceneLevels.all.slice(4).reduce((a, b) => a + b.length, 0),
      sceneLevels.main.slice(4).reduce((a, v) => a + v),
    ],
  ];
  const sceneStrArr = getSceneStrArr(declaration, sceneLevels, sceneUpperArr);
  return {
    answer11Year: answer11.otherAns.version
      ? answer11.otherAns.year
      : [2021, 2022, 2023],
    answer12Year: answer12.otherAns.version
      ? answer12.otherAns.year
      : [2022, 2023],
    answer14Year: answer14.otherAns.version
      ? answer14.otherAns.year
      : [2022, 2023],
    answer15Year: answer15.otherAns.version
      ? answer15.otherAns.year
      : [2022, 2023],
    i: info,
    e: expert,
    d: declaration,
    // a: avgData,
    a: {},
    levelName: declaration.levelName,
    score: declaration.score,
    levelsName,
    scoreLevel,
    scenesLevel,
    sceneUpperArr,
    sceneStrArr,
    sceneParts,
    answerArr: [
      answer1,
      answer2,
      answer3,
      answer4,
      answer5,
      answer6,
      answer7,
      answer8,
      answer9,
      answer10,
      answer11,
      answer12,
      answer13,
      answer14,
      answer15,
    ],
    sceneArr: [
      scene1,
      scene2,
      scene3,
      scene4,
      scene5,
      scene6,
      scene7,
      scene8,
      scene9,
      scene10,
      scene11,
      scene12,
      scene13,
      scene14,
      scene15,
      scene16,
    ],
    userId: info.userId,
    eName: info.enterpriseName,
    eRemark: info.remark,
    partOne,
    partTwo,
    partThree,
    strOne: "赵依依",
    strTwo: "钱尔尔、孙散散、李思思",
    strThree: "周五五",
    strFive: "1869633404786446337",
    strSix: "1869632325336174593",
    strSeven: [],
    strRight: [],
    strNine: [],
    p_2_1:
      "数字化基础、数字化管理、数字化成效三个维度的评测指标，由 3 个一级指标，9 个二级指标，15 个采集项组成。采用评分方式判定中小企业该部分数字化水平等级。",
    p_2_1_0: `试点企业在三个维度的评测得分为 ${declaration.score} 分（${scoreLevel}），具体情况如下：`,
    p_2_1_a: `——数字化基础（A）维度一级指标评测得分为 ${
      partOne * 1 || 0
    } 分（满分 50 分，得分率 ${
      ((partOne / 50) * 100).toFixed(3) * 1 || 0
    }%），其中：（A1）设备系统 ${
      declaration.partOne * 1 || 0
    } 分、（A2）数据采集 ${declaration.partTwo * 1 || 0} 分、（A3）信息系统 ${
      declaration.partThree * 1 || 0
    } 分、（A4）信息安全 ${declaration.partFour * 1 || 0} 分。`,
    p_2_1_b: `——数字化管理（B）维度一级指标评测得分为 ${
      partTwo * 1 || 0
    } 分（满分 30 分，得分率 ${
      ((partTwo / 30) * 100).toFixed(3) * 1 || 0
    }%），其中：（B1）规划管理 ${
      declaration.partFive * 1 || 0
    } 分、（B2）要素保障 ${declaration.partSix * 1 || 0} 分。`,
    p_2_1_c: `——数字化成效（C）维度一级指标评测得分为 ${
      partThree * 1 || 0
    } 分（满分 20 分，得分率 ${
      ((partThree / 20) * 100).toFixed(3) * 1 || 0
    }%）其中：（C1）绿色低碳 ${
      declaration.partSeven * 1 || 0
    } 分、（C2）产品质量 ${declaration.partEight * 1 || 0} 分、（C3）市场效益 ${
      declaration.partNine * 1 || 0
    } 分。`,
    p_2_1_a_0: `该二级指标评测得分 ${
      declaration.partOne * 1 || 0
    } 分（满分 20 分，得分率 ${
      ((declaration.partOne / 20) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_a_1: `该采集项评测得分 ${
      answer1.score * 1 || 0
    } 分（满分 8 分，得分率 ${
      ((answer1.score / 8) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_a_2: `企业网络建设连接情况：${answer1.ans
      .map((v) => v.name.replace(/^无$/, "没有任何网络建设").split("，")[0])
      .join("；")}。`,
    p_2_1_a_3: `该采集项评测得分 ${
      answer2.score * 1 || 0
    } 分（满分 6 分，得分率 ${
      ((answer2.score / 6) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_a_4: `企业的生产设备数字化率为 ${
      answer2.otherAns.digitRate * 1 || 0
    }%。`,
    p_2_1_a_5: `该采集项评测得分 ${
      answer3.score * 1 || 0
    } 分（满分 6 分，得分率 ${
      ((answer3.score / 6) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_a_6: `企业的生产设备联网率为 ${
      answer2.otherAns.onlineRate * 1 || 0
    }%。`,
    p_2_1_b_1: `该二级指标及采集项评测得分 ${
      answer4.score * 1 || 0
    } 分（满分 10 分，得分率 ${
      ((answer4.score / 10) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_b_2: `企业实现数据自动采集的业务环节覆盖范围涵盖了${answer4More[0]} ${answer4More[1]} 个业务环节；${answer4More[2]} ${answer4More[3]} 个业务环节尚未实现数据自动采集。`,
    p_2_1_c_1: `该二级指标及采集项评测得分 ${
      answer5.score * 1 || 0
    } 分（满分 10 分，得分率 ${
      ((answer5.score / 10) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_c_2: `企业使用本地或云化部署的信息化服务，实现业务的数字化管理情况：${answer5More}。`,
    p_2_1_d_1: `该二级指标评测得分 ${
      declaration.partFour * 1 || 0
    } 分（满分 10 分，得分率  ${
      ((declaration.partFour / 10) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_d_2: `该采集项评测得分 ${
      answer6.score * 1 || 0
    } 分（满分 5 分，得分率 ${
      ((answer6.score / 5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_d_3: `企业在保障网络安全方面采取的举措：${answer6More}。`,
    p_2_1_d_4: `该采集项评测得分 ${
      answer7.score * 1 || 0
    } 分（满分 5 分，得分率 ${
      ((answer7.score / 5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_2_1_d_5: `企业在保障数据安全方面采取的举措：${answer7More}。`,
    p_a_1: `该二级指标评测得分 ${
      declaration.partFive * 1 || 0
    } 分（满分 15 分，得分率 ${
      ((declaration.partFive / 15) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_2: `该采集项评测得分 ${
      answer8.score * 1 || 0
    } 分（满分 7.5 分，得分率 ${
      ((answer8.score / 7.5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_3: `企业对数字化的认识与执行水平情况：${answer8More}。`,
    p_a_4: `该采集项评测得分 ${
      answer9.score * 1 || 0
    } 分（满分 7.5 分，得分率 ${
      ((answer9.score / 7.5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_5: `企业数字化管理制度的建立情况：${answer9More}。`,
    p_a_6: `该二级指标评测得分 ${
      declaration.partSix * 1 || 0
    } 分（满分 15 分，得分率 ${
      ((declaration.partSix / 15) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_7: `该采集项评测得分 ${
      answer10.score * 1 || 0
    } 分（满分 7.5 分，得分率 ${
      ((answer10.score / 7.5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_8: `企业在数字化人才建设方面采取的举措：${answer10More}。`,
    p_a_9: `该采集项评测得分 ${
      answer11.score * 1 || 0
    } 分（满分 7.5 分，得分率 ${
      ((answer11.score / 7.5) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_a_10: `企业近三年平均数字化投入总额占营业额的平均比例为 ${
      (answer11.otherAns.result * 1).toFixed(3) * 1 || 0
    }%。`,
    p_a_11: `${
      answer11.otherAns.version ? answer11.otherAns.year[2] : "2023"
    } 年数字化投入 ${
      (answer11.otherAns.digitInput[2] * 1).toFixed(3) * 1 || 0
    } 万元，营业收入 ${
      (answer11.otherAns.revenue[2] * 1).toFixed(3) * 1 || 0
    } 万元，比例为 ${(answer11.otherAns.x3 * 100).toFixed(3) * 1 || 0}%；`,
    p_a_12: `${
      answer11.otherAns.version ? answer11.otherAns.year[1] : "2022"
    } 年数字化投入 ${
      (answer11.otherAns.digitInput[1] * 1).toFixed(3) * 1 || 0
    } 万元，营业收入 ${
      (answer11.otherAns.revenue[1] * 1).toFixed(3) * 1 || 0
    } 万元，比例为 ${(answer11.otherAns.x2 * 100).toFixed(3) * 1 || 0}%；`,
    p_a_13: `${
      answer11.otherAns.version ? answer11.otherAns.year[0] : "2021"
    } 年数字化投入 ${
      (answer11.otherAns.digitInput[0] * 1).toFixed(3) * 1 || 0
    } 万元，营业收入 ${
      (answer11.otherAns.revenue[0] * 1).toFixed(3) * 1 || 0
    } 万元，比例为 ${(answer11.otherAns.x1 * 100).toFixed(3) * 1 || 0}%。`,
    p_a_14: "",
    p_b_1: `该二级指标及采集项评测得分 ${
      answer12.score * 1 || 0
    } 分（满分 7 分，得分率 ${
      ((answer12.score / 7) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_b_2:
      answer12.otherAns.result === 0 &&
      answer12.otherAns.after === 0 &&
      answer12.otherAns.before === 0
        ? "企业数字化改造后每百元营业收入中综合能源消费量因数据不足，不能给出变化情况"
        : `企业数字化改造后每百元营业收入中综合能源消费量相比于改造前的变化情况：${answer12.ans.name}。`,
    p_b_3: `企业数字化改造后综合能源消费量为${
      (answer12.otherAns.afterCost || 0).toFixed(3) * 1 || 0
    }吨标准煤；`,
    p_b_4: `企业数字化改造前综合能源消费量为${
      (answer12.otherAns.beforeCost || 0).toFixed(3) * 1 || 0
    }吨标准煤。`,
    p_b_5: `该二级指标及采集项评测得分 ${
      answer13.score * 1 || 0
    } 分（满分 7 分，得分率 ${
      ((answer13.score / 7) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_b_6: `企业数字化改造后月均产品合格率相比于改造前的变化情况：${answer13.ans.name}。`,
    p_b_7: `企业数字化改造前的月均产品合格率为 ${
      answer13.otherAns.before * 1 || 0
    }%，数字化改造后的月均产品合格率为${answer13.otherAns.after * 1 || 0}%。`,
    p_b_8: `该二级指标评测得分 ${
      declaration.partNine * 1 || 0
    } 分（满分 6 分，得分率 ${
      ((declaration.partNine / 6) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_b_9: `该采集项评测得分 ${answer14.score * 1 || 0} 分（满分 3 分，得分率 ${
      ((answer14.score / 3) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_b_10: `企业上年度人均营业收入相比于前年变化情况：${answer14.ans.name}。`,
    p_b_11: `${
      answer14.otherAns.version ? answer14.otherAns.year[1] : "2023"
    } 年营业收入 ${answer14.otherAns.thisYear.personRevenue} 万元，员工数量 ${
      answer14.otherAns.thisYear.personCount
    } 人，人均营业收入为 ${
      (answer14.otherAns.thisYear.average * 1 || 0).toFixed(3) * 1 || 0
    }万元/人；`,
    p_b_12: `${
      answer14.otherAns.version ? answer14.otherAns.year[0] : "2022"
    } 年营业收入 ${answer14.otherAns.lastYear.personRevenue} 万元，员工数量 ${
      answer14.otherAns.lastYear.personCount
    } 人，人均营业收入为 ${
      (answer14.otherAns.lastYear.average * 1 || 0).toFixed(3) * 1 || 0
    }万元/人。`,
    p_b_13: `该采集项评测得分 ${
      answer15.score * 1 || 0
    } 分（满分 3 分，得分率 ${
      ((answer15.score / 3) * 100).toFixed(3) * 1 || 0
    }%）。`,
    p_b_14: `企业上年度每百元营业收入中的成本相比于前年变化情况：${answer15.ans.name}。`,
    p_b_15: "",
    p_b_16: `${
      answer15.otherAns.version ? answer15.otherAns.year[1] : "2023"
    } 年成本 ${
      (answer15.otherAns.thisYear.cost * 1).toFixed(3) * 1 || 0
    } 万元，营业收入 ${
      answer15.otherAns.thisYear.personRevenue
    } 万元，每百元营业收入中的成本为 ${
      (answer15.otherAns.thisYear.perCost * 1).toFixed(3) * 1 || 0
    } 元；`,
    p_b_17: `${
      answer15.otherAns.version ? answer15.otherAns.year[0] : "2022"
    } 年成本 ${
      (answer15.otherAns.lastYear.cost * 1).toFixed(3) * 1 || 0
    } 万元，营业收入 ${
      answer15.otherAns.lastYear.personRevenue
    } 万元，每百元营业收入中的成本为 ${
      (answer15.otherAns.lastYear.perCost * 1).toFixed(3) * 1 || 0
    } 元。`,
    p_c_1: `试点企业在数字化经营维度的应用场景等级判定为${declaration.levelName}，具体情况如下：`,
    p_c_2: `——产品生命周期数字化（D）应用场景等级判定 4 个，其中：（D1*）产品设计${scene1.levelName}、（D2）工艺设计${scene2.levelName}、（D3*）营销管理${scene3.levelName}、（D4）售后服务${scene4.levelName}。`,
    p_c_3: `——生产执行数字化（E）应用场景等级判定 6 个，其中：（E1）计划排程${scene5.levelName}、（E2*）生产管控${scene6.levelName}、（E3*）质量管理${scene7.levelName}、（E4*）设备管理${scene8.levelName}、（E5*）安全生产${scene9.levelName}、（E6*）能耗管理${scene10.levelName}。`,
    p_c_4: `——供应链数字化（F）应用场景等级判定 2 个，其中：（F1*）采购管理${scene11.levelName}、（E2*）仓储物流${scene12.levelName}。`,
    p_c_5: `——管理决策数字化（G）应用场景等级判定 4 个，其中：（G1*）财务管理${scene13.levelName}（G2）人力资源${scene14.levelName}、（G3）协同办公${scene15.levelName}、（G4）决策支持${scene16.levelName}。`,
    p_d_1: sceneMainStr,
    p_d_2: sceneNormalStr,
    p_e_1: `该二级指标应用场景${
      scene1.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene1.levelName}`
    }。`,
    p_e_2: `${sceneStr1}`,
    p_e_4: `该二级指标应用场景${
      scene2.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene2.levelName}`
    }。`,
    p_e_5: `${sceneStr2}`,
    p_e_6: `该二级指标应用场景${
      scene3.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene3.levelName}`
    }。`,
    p_e_7: `${sceneStr3}`,
    p_e_8: `该二级指标应用场景${
      scene4.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene4.levelName}`
    }。`,
    p_e_9: `${sceneStr4}`,
    p_f_1: `该二级指标应用场景${
      scene5.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene5.levelName}`
    }。`,
    p_f_2: `${sceneStr5}`,
    p_f_3: `该二级指标应用场景${
      scene6.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene6.levelName}`
    }。`,
    p_f_4: `${sceneStr6}`,
    p_f_5: `该二级指标应用场景${
      scene7.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene7.levelName}`
    }。`,
    p_f_6: `${sceneStr7}`,
    p_f_7: `该二级指标应用场景${
      scene8.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene8.levelName}`
    }。`,
    p_f_8: `${sceneStr8}`,
    p_f_9: `该二级指标应用场景${
      scene9.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene9.levelName}`
    }。`,
    p_f_10: `${sceneStr9}`,
    p_f_11: `该二级指标应用场景${
      scene10.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene10.levelName}`
    }。`,
    p_f_12: `${sceneStr10}`,
    p_g_1: `该二级指标应用场景${
      scene11.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene11.levelName}`
    }。`,
    p_g_2: `${sceneStr11}`,
    p_g_3: `该二级指标应用场景${
      scene12.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene12.levelName}`
    }。`,
    p_g_4: `${sceneStr12}`,
    p_h_1: `该二级指标应用场景${
      scene13.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene13.levelName}`
    }。`,
    p_h_2: `${sceneStr13}`,
    p_h_3: `该二级指标应用场景${
      scene14.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene14.levelName}`
    }。`,
    p_h_4: `${sceneStr14}`,
    p_h_5: `该二级指标应用场景${
      scene15.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene15.levelName}`
    }。`,
    p_h_6: `${sceneStr15}`,
    p_h_7: `该二级指标应用场景${
      scene16.level === 0
        ? "试点企业未参与评测"
        : `等级判定为${scene16.levelName}`
    }。`,
    p_h_8: `${sceneStr16}`,
    p_i_1: "",
    p_i_2: "",
  };
}

function calcScenes(scenes) {
  const scenePart1 = []
    .concat(scenes[0].level > 0 ? `（D1*）产品设计${scenes[0].levelName}` : [])
    .concat(scenes[1].level > 0 ? `（D2）工艺设计${scenes[1].levelName}` : [])
    .concat(scenes[2].level > 0 ? `（D3*）营销管理${scenes[2].levelName}` : [])
    .concat(scenes[3].level > 0 ? `（D4）售后服务${scenes[3].levelName}` : []);
  const scenePart2 = []
    .concat(scenes[4].level > 0 ? `（E1）计划排程${scenes[4].levelName}` : [])
    .concat(scenes[5].level > 0 ? `（E2*）生产管控${scenes[5].levelName}` : [])
    .concat(scenes[6].level > 0 ? `（E3*）质量管理${scenes[6].levelName}` : [])
    .concat(scenes[7].level > 0 ? `（E4*）设备管理${scenes[7].levelName}` : [])
    .concat(scenes[8].level > 0 ? `（E5*）安全生产${scenes[8].levelName}` : [])
    .concat(scenes[9].level > 0 ? `（E6*）能耗管理${scenes[9].levelName}` : []);
  const scenePart3 = []
    .concat(
      scenes[10].level > 0 ? `（F1*）采购管理${scenes[10].levelName}` : []
    )
    .concat(
      scenes[11].level > 0 ? `（F2*）仓储物流${scenes[11].levelName}` : []
    );
  const scenePart4 = []
    .concat(
      scenes[12].level > 0 ? `（G1*）财务管理${scenes[12].levelName}` : []
    )
    .concat(scenes[13].level > 0 ? `（G2）人力资源${scenes[13].levelName}` : [])
    .concat(scenes[14].level > 0 ? `（G3）协同办公${scenes[14].levelName}` : [])
    .concat(
      scenes[15].level > 0 ? `（G4）决策支持${scenes[15].levelName}` : []
    );
  const categories = [
    "D1*",
    "D2",
    "D3*",
    "D4",
    "E1",
    "E2*",
    "E3*",
    "E4*",
    "E5*",
    "E6*",
    "F1*",
    "F2*",
    "G1*",
    "G2",
    "G3",
    "G4",
  ];
  debugger;
  const mainPart = scenes.reduce(
    (o, v, i) => {
      o[v.ques.isMain ? "main" : "normal"][v.level].push(
        Object.assign({}, v, { category: categories[i] })
      );
      return o;
    },
    { main: [[], [], [], [], []], normal: [[], [], [], [], []] }
  );
  return {
    part1: scenePart1,
    part2: scenePart2,
    part3: scenePart3,
    part4: scenePart4,
    mainCount: mainPart.main.reduce(
      (t, v, i) => t + (i !== 0 ? v.length : 0),
      0
    ),
    normalCount: mainPart.normal.reduce(
      (t, v, i) => t + (i !== 0 ? v.length : 0),
      0
    ),
    main: mainPart.main.reduce(
      (a, v, i) =>
        a.concat(
          i !== 0 && v.length > 0
            ? `${v[0].levelName} ${v.length} 个（${v
                .map((v) => v.category)
                .join("、")}）`
            : []
        ),
      []
    ),
    normal: mainPart.normal.reduce(
      (a, v, i) =>
        a.concat(
          i !== 0 && v.length > 0
            ? `${v[0].levelName} ${v.length} 个（${v
                .map((v) => v.category)
                .join("、")}）`
            : []
        ),
      []
    ),
  };
}

function getSceneStrArr(declaration, sceneLevels, sceneUpperArr) {
  const level1 = {
    content:
      sceneUpperArr[0][0] +
      "个应用场景（其中" +
      sceneUpperArr[0][1] +
      "个约束性场景）等级达到一级及以上",
    cl: "text-gray-level",
  };
  const level2 = {
    content:
      sceneUpperArr[1][0] +
      "个应用场景（其中" +
      sceneUpperArr[1][1] +
      "个约束性场景）等级达到二级及以上",
    cl: "text-yellow-level",
  };
  const level3 = {
    content:
      sceneUpperArr[2][0] +
      "个应用场景（其中" +
      sceneUpperArr[2][1] +
      "个约束性场景）等级达到三级及以上",
    cl: "text-blue-level",
  };
  const level4 = {
    content:
      sceneUpperArr[3][0] +
      "个应用场景（其中" +
      sceneUpperArr[3][1] +
      "个约束性场景）等级达到四级及以上",
    cl: "text-purple-level",
  };
  if (declaration.levelName === "四级") {
    return [level4];
  } else if (declaration.levelName === "二级") {
    return [level2];
  } else if (declaration.levelName === "三级") {
    return [level3];
  } else {
    return [level1];
  }
}

function getAnswer4Str(answer) {
  const scene = [
    "产品设计",
    "工艺设计",
    "营销管理",
    "售后服务",
    "计划排程",
    "生产管控",
    "质量管理",
    "设备管理",
    "安全生产",
    "能耗管理",
    "采购管理",
    "仓储物流",
    "财务管理",
    "人力资源",
  ];
  if (answer.ans.some((v) => v.name === "无")) {
    return ["", 0, scene.join("、") + "等", 14];
  } else {
    const names = scene.filter((v) => answer.ans.find((a) => a.name === v));
    const never = scene.filter((v) => !names.includes(v));
    return [
      names.join("、") + "等",
      names.length,
      never.length > 0 ? never.join("、") + "等" : "",
      never.length,
    ];
  }
}

function getAnswer5Str(answer) {
  const list = [
    "产品设计",
    "工艺设计",
    "营销管理",
    "售后服务",
    "计划排程",
    "生产管控",
    "质量管理",
    "设备管理",
    "安全生产",
    "能耗管理",
    "采购管理",
    "仓储物流",
    "财务管理",
    "人力资源",
  ];
  const keys = list.filter((_, i) => answer.otherAns[i]);
  if (keys.length === 0) {
    return "企业的业务环节均未实现数字化管理";
  } else {
    const answer5More = [
      keys.join("、") + "等",
      keys.length,
      keys.length < 2
        ? "即单个环节"
        : keys.length < 12
        ? "即多个业务环节，不足指标推荐的 14 个业务环节的 80%"
        : keys.length < 14
        ? "即绝大部分业务环节，超过指标推荐的 14 个业务环节的 80%"
        : "即全覆盖",
    ];
    return `企业的${answer5More[0]} ${answer5More[1]} 个业务环节实现数字化管理（${answer5More[2]}）`;
  }
}

function getAnswer6Str(answer) {
  console.log(answer);
  return answer.ans.length === 0 || answer.ans.some((v) => v.name === "无")
    ? "没有任何举措"
    : answer.ans.map((v) => v.name).join("；");
}

function getAnswer7Str(answer) {
  return answer.ans.length === 0 || answer.ans.some((v) => v.name === "无")
    ? "没有任何举措"
    : answer.ans.map((v) => v.name).join("；");
}

function getAnswer8Str(answer) {
  return !answer.ans.name || answer.ans.name === "无"
    ? "没有任何执行"
    : answer.ans.name;
}

function getAnswer9Str(answer) {
  return answer.ans.length === 0 || answer.ans.some((v) => v.name === "无")
    ? "没有任何建设"
    : answer.ans.map((v) => v.name).join("；");
}

function getAnswer10Str(answer) {
  return answer.ans.length === 0 || answer.ans.some((v) => v.name === "无")
    ? "没有任何举措"
    : answer.ans.map((v) => v.name).join("；");
}

function getSceneMainStr(arr) {
  const list = [
    "D1*",
    "D3*",
    "E2*",
    "E3*",
    "E4*",
    "E5*",
    "E6*",
    "F1*",
    "F2*",
    "G1*",
  ];
  const sceneLevels = arr.reduce(
    (a, v, i) => {
      a[v.level].push(list[i]);
      return a;
    },
    [[], [], [], [], []]
  );
  const upper1 = sceneLevels.slice(1).reduce((t, v) => t + v.length, 0);
  return `其中：一级 ${sceneLevels[1].length} 个${
    sceneLevels[1].length > 0 ? "（" + sceneLevels[1].join("、") + "）" : ""
  }、二级 ${sceneLevels[2].length} 个${
    sceneLevels[2].length > 0 ? "（" + sceneLevels[2].join("、") + "）" : ""
  }、三级 ${sceneLevels[3].length} 个${
    sceneLevels[3].length > 0 ? "（" + sceneLevels[3].join("、") + "）" : ""
  }、四级 ${sceneLevels[4].length} 个${
    sceneLevels[4].length > 0 ? "（" + sceneLevels[4].join("、") + "）" : ""
  }${upper1 >= 10 ? "。" : "，其余未评级。"}`;
}

function getSceneNormalStr(arr) {
  const list = ["D2", "D4", "E1", "G2", "G3", "G4"];
  const sceneLevels = arr.reduce(
    (a, v, i) => {
      a[v.level].push(list[i]);
      return a;
    },
    [[], [], [], [], []]
  );
  const upper1 = sceneLevels.slice(1).reduce((t, v) => t + v.length, 0);
  return `其中：一级 ${sceneLevels[1].length} 个${
    sceneLevels[1].length > 0 ? "（" + sceneLevels[1].join("、") + "）" : ""
  }、二级 ${sceneLevels[2].length} 个${
    sceneLevels[2].length > 0 ? "（" + sceneLevels[2].join("、") + "）" : ""
  }、三级 ${sceneLevels[3].length} 个${
    sceneLevels[3].length > 0 ? "（" + sceneLevels[3].join("、") + "）" : ""
  }、四级 ${sceneLevels[4].length} 个${
    sceneLevels[4].length > 0 ? "（" + sceneLevels[4].join("、") + "）" : ""
  }${upper1 >= 6 ? "。" : "，其余未评级。"}`;
}

function transToForm(backend, report) {
  const strOne = JSON.parse(report.strOne || "[]");
  const strSeven = JSON.parse(report.strSeven || "[]");
  const strRight = JSON.parse(report.strRight || "[]");
  const strNine = JSON.parse(report.strNine || "[]");
  const partOne = JSON.parse(report.partOne || "[]");
  const partTwo = JSON.parse(report.partTwo || "[]");
  const partThree = JSON.parse(report.partThree || "[]");
  const partFour = JSON.parse(report.partFour || "[]");
  const partFive = JSON.parse(report.partFive || "[]");
  const partSix = JSON.parse(report.partSix || "[]");
  const partSeven = JSON.parse(report.partSeven || "[]");
  const partEight = JSON.parse(report.partEight || "[]");
  const partNine = JSON.parse(report.partNine || "[]");
  if (report.reportNum) {
    return Object.assign({}, backend, {
      userId: report.userId,
      reportNum: report.reportNum,
      reportDate: new Date(report.reportDate),
      eName: report.epName,
      eRemark: report.epRemark,
      strOne: strOne[0],
      strTwo: strOne[1],
      strThree: strOne[2],
      strFive: report.strFive || backend.strFive,
      strSix: report.strSix || backend.strSix,
      strSeven: strSeven,
      strRight: strRight,
      strNine: strNine,
      p_2_1: partOne[0],
      p_2_1_0: partOne[1],
      p_2_1_a: partOne[2],
      p_2_1_b: partOne[3],
      p_2_1_c: partOne[4],
      p_2_1_a_0: partOne[5],
      p_2_1_a_1: partOne[6],
      p_2_1_a_2: partOne[7],
      p_2_1_a_3: partOne[8],
      p_2_1_a_4: partOne[9],
      p_2_1_a_5: partOne[10],
      p_2_1_a_6: partOne[11],
      p_2_1_b_1: partOne[12],
      p_2_1_b_2: partOne[13],
      p_2_1_c_1: partOne[14],
      p_2_1_c_2: partOne[15],
      p_2_1_d_1: partOne[16],
      p_2_1_d_2: partOne[17],
      p_2_1_d_3: partOne[18],
      p_2_1_d_4: partOne[19],
      p_2_1_d_5: partOne[20],
      p_a_1: partTwo[0],
      p_a_2: partTwo[1],
      p_a_3: partTwo[2],
      p_a_4: partTwo[3],
      p_a_5: partTwo[4],
      p_a_6: partTwo[5],
      p_a_7: partTwo[6],
      p_a_8: partTwo[7],
      p_a_9: partTwo[8],
      p_a_10: partTwo[9],
      p_a_11: partTwo[10],
      p_a_12: partTwo[11],
      p_a_13: partTwo[12],
      p_a_14: partTwo[13],
      p_b_1: partThree[0],
      p_b_2: partThree[1],
      p_b_3: partThree[2],
      p_b_4: partThree[3],
      p_b_5: partThree[4],
      p_b_6: partThree[5],
      p_b_7: partThree[6],
      p_b_8: partThree[7],
      p_b_9: partThree[8],
      p_b_10: partThree[9],
      p_b_11: partThree[10],
      p_b_12: partThree[11],
      p_b_13: partThree[12],
      p_b_14: partThree[13],
      p_b_15: partThree[14],
      p_b_16: partThree[15],
      p_b_17: partThree[16],
      p_c_1: partFour[0],
      p_c_2: partFour[1],
      p_c_3: partFour[2],
      p_c_4: partFour[3],
      p_c_5: partFour[4],
      p_d_1: partFive[0],
      p_d_2: partFive[1],
      p_e_1: partSix[0],
      p_e_2: partSix[1],
      p_e_4: partSix[3],
      p_e_5: partSix[4],
      p_e_6: partSix[5],
      p_e_7: partSix[6],
      p_e_8: partSix[7],
      p_e_9: partSix[8],
      p_f_1: partSeven[0],
      p_f_2: partSeven[1],
      p_f_3: partSeven[2],
      p_f_4: partSeven[3],
      p_f_5: partSeven[4],
      p_f_6: partSeven[5],
      p_f_7: partSeven[6],
      p_f_8: partSeven[7],
      p_f_9: partSeven[8],
      p_f_10: partSeven[9],
      p_f_11: partSeven[10],
      p_f_12: partSeven[11],
      p_g_1: partEight[0],
      p_g_2: partEight[1],
      p_g_3: partEight[2],
      p_g_4: partEight[3],
      p_h_1: partNine[0],
      p_h_2: partNine[1],
      p_h_3: partNine[2],
      p_h_4: partNine[3],
      p_h_5: partNine[4],
      p_h_6: partNine[5],
      p_h_7: partNine[6],
      p_h_8: partNine[7],
      p_i_1: report.textOne,
      p_i_2: report.textTwo,
    });
  } else {
    return Object.assign({}, backend);
  }
}

function transToData(form) {
  return Object.assign({
    reportDate: formatDate(form.reportDate) + " 00:00:00",
    userId: form.userId,
    epName: form.eName,
    epRemark: form.eRemark,
    strOne: JSON.stringify([form.strOne, form.strTwo, form.strThree]),
    strFive: form.strFive,
    strSix: form.strSix,
    strSeven: JSON.stringify(form.strSeven),
    strRight: JSON.stringify(form.strRight),
    strNine: JSON.stringify(form.strNine),
    partOne: JSON.stringify([
      form.p_2_1,
      form.p_2_1_0,
      form.p_2_1_a,
      form.p_2_1_b,
      form.p_2_1_c,
      form.p_2_1_a_0,
      form.p_2_1_a_1,
      form.p_2_1_a_2,
      form.p_2_1_a_3,
      form.p_2_1_a_4,
      form.p_2_1_a_5,
      form.p_2_1_a_6,
      form.p_2_1_b_1,
      form.p_2_1_b_2,
      form.p_2_1_c_1,
      form.p_2_1_c_2,
      form.p_2_1_d_1,
      form.p_2_1_d_2,
      form.p_2_1_d_3,
      form.p_2_1_d_4,
      form.p_2_1_d_5,
    ]),
    partTwo: JSON.stringify([
      form.p_a_1,
      form.p_a_2,
      form.p_a_3,
      form.p_a_4,
      form.p_a_5,
      form.p_a_6,
      form.p_a_7,
      form.p_a_8,
      form.p_a_9,
      form.p_a_10,
      form.p_a_11,
      form.p_a_12,
      form.p_a_13,
      form.p_a_14,
    ]),
    partThree: JSON.stringify([
      form.p_b_1,
      form.p_b_2,
      form.p_b_3,
      form.p_b_4,
      form.p_b_5,
      form.p_b_6,
      form.p_b_7,
      form.p_b_8,
      form.p_b_9,
      form.p_b_10,
      form.p_b_11,
      form.p_b_12,
      form.p_b_13,
      form.p_b_14,
      form.p_b_15,
      form.p_b_16,
      form.p_b_17,
    ]),
    partFour: JSON.stringify([
      form.p_c_1,
      form.p_c_2,
      form.p_c_3,
      form.p_c_4,
      form.p_c_5,
    ]),
    partFive: JSON.stringify([form.p_d_1, form.p_d_2]),
    partSix: JSON.stringify([
      form.p_e_1,
      form.p_e_2,
      "",
      form.p_e_4,
      form.p_e_5,
      form.p_e_6,
      form.p_e_7,
      form.p_e_8,
      form.p_e_9,
    ]),
    partSeven: JSON.stringify([
      form.p_f_1,
      form.p_f_2,
      form.p_f_3,
      form.p_f_4,
      form.p_f_5,
      form.p_f_6,
      form.p_f_7,
      form.p_f_8,
      form.p_f_9,
      form.p_f_10,
      form.p_f_11,
      form.p_f_12,
    ]),
    partEight: JSON.stringify([form.p_g_1, form.p_g_2, form.p_g_3, form.p_g_4]),
    partNine: JSON.stringify([
      form.p_h_1,
      form.p_h_2,
      form.p_h_3,
      form.p_h_4,
      form.p_h_5,
      form.p_h_6,
      form.p_h_7,
      form.p_h_8,
    ]),
    textOne: form.p_i_1,
    textTwo: form.p_i_2,
  });
}

function formatDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
}
</script>
